import { isFeatureEnabled } from "../utils";

const NEW_ONBOARDING_FLAG = "new_onboarding_flow";

const getBuildExperienceMode = () => {
  const raw = (process.env.REACT_APP_EXPERIENCE_MODE || "auto")
    .toString()
    .trim()
    .toLowerCase();
  return raw;
};

export const getNewExperienceEnabled = (profile) => {
  const buildMode = getBuildExperienceMode();
  if (buildMode === "legacy") return false;
  if (buildMode === "new" || buildMode === "mvp") return true;

  try {
    const override = localStorage.getItem("legacy_experience_override");
    if (override === "true") return false;
    if (override === "false") return true;
  } catch (error) {
    // Ignore storage issues and fall back to profile flags
  }

  return profile ? isFeatureEnabled(profile, NEW_ONBOARDING_FLAG) : false;
};
